import { render, staticRenderFns } from "./Goal.vue?vue&type=template&id=398412e8&scoped=true&"
import script from "./Goal.vue?vue&type=script&lang=js&"
export * from "./Goal.vue?vue&type=script&lang=js&"
import style0 from "./Goal.vue?vue&type=style&index=0&id=398412e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398412e8",
  null
  
)

export default component.exports